import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/client';
import { BadgeCheck, ShieldX, Loader2, Award } from 'lucide-react';

export default function CertVerifyPage() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/trainees/certifications/verify/${code}`)
      .then(r => setData(r.data))
      .catch(() => setData({ found: false, valid: false }))
      .finally(() => setLoading(false));
  }, [code]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="cert-verify-page">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border p-8 text-center">
        <div className="flex items-center justify-center gap-2 text-[#1A3C6E] font-display font-bold text-lg mb-6">
          <Award className="w-5 h-5 text-amber-500" /> Lumyn — Certificate Verification
        </div>
        {loading ? (
          <div className="py-10 text-muted-foreground"><Loader2 className="w-6 h-6 animate-spin inline" /></div>
        ) : !data?.found ? (
          <div className="py-6" data-testid="cert-verify-notfound">
            <ShieldX className="w-14 h-14 text-slate-400 mx-auto mb-3" />
            <div className="font-display font-bold text-xl">Not found</div>
            <p className="text-sm text-muted-foreground mt-1">No certificate matches code <span className="font-mono">{code}</span>.</p>
          </div>
        ) : data.valid ? (
          <div className="py-2" data-testid="cert-verify-valid">
            <BadgeCheck className="w-16 h-16 text-emerald-500 mx-auto mb-3" />
            <div className="inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-semibold uppercase tracking-wide mb-4">Verified</div>
            <div className="text-2xl font-display font-bold text-[#1A3C6E]">{data.trainee_name}</div>
            <p className="text-sm text-muted-foreground mt-2">successfully completed</p>
            <p className="text-base font-medium mt-1">{data.program_name}</p>
            {data.batch_name && <p className="text-sm text-muted-foreground mt-1">Batch: {data.batch_name}</p>}
            <p className="text-xs text-muted-foreground mt-4">Issued {(data.issued_at || '').slice(0, 10)} · Code {data.verify_code}</p>
          </div>
        ) : (
          <div className="py-6" data-testid="cert-verify-revoked">
            <ShieldX className="w-14 h-14 text-rose-500 mx-auto mb-3" />
            <div className="font-display font-bold text-xl text-rose-600">Revoked</div>
            <p className="text-sm text-muted-foreground mt-1">This certificate ({data.verify_code}) is no longer valid.</p>
          </div>
        )}
      </div>
    </div>
  );
}
